module.exports = __webpack_public_path__ + "static/media/news-3.f304cf5e.jpg";